<div class="competers-modal">
  <div class="competers-modal-body" [style.max-width]="maxwidth" [style.height]="height">
    <ng-content class="compters-modal-header"></ng-content>
    <ng-content class="competers-modal-content"></ng-content>
    <ng-content class="compters-modal-footer"></ng-content>
  </div>
</div>
<div class="competers-modal-background"></div>
